
import ForumPostDetail from '../../components/ForumPostDetail';

export default function BehindScenesDetailPage() {
  return <ForumPostDetail categoryId="behind-scenes" />;
}
